import { useCallback, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

import { Translation } from 'cng-common/features/translations/components/translation'

import {
  PROGRESS_VIEW_DESC_SUFFIX,
  PROGRESS_VIEW_ITEMS,
  PROGRESS_VIEW_LABEL_SUFFIX,
} from '../../../../lpKeyInitiatives/components/keyInitiativeEditorModal/configs'
import { TRANSLATION_KEYS as tr } from '../../../../translations'

import styles from './ProgressDropdown.module.scss'

interface IProgressDropdownProps {
  progressItems: string[]
  onToggleItem: (key: string) => void
}

export const ProgressDropdown = ({ progressItems, onToggleItem }: IProgressDropdownProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({})
  const toggleRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (isDropdownOpen && toggleRef.current) {
      const rect = toggleRef.current.getBoundingClientRect()
      setMenuStyle({
        position: 'fixed',
        top: rect.bottom,
        left: rect.left,
        width: rect.width,
      })
    }
  }, [isDropdownOpen])

  const handleToggleItem = useCallback(
    (key: string) => {
      onToggleItem(key)
    },
    [onToggleItem]
  )

  return (
    <div className={styles.dropdown}>
      <button
        ref={toggleRef}
        type="button"
        className={styles.dropdownToggle}
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        <span>
          {progressItems.length ? (
            `${progressItems.length} item(s) selected`
          ) : (
            <Translation text={tr.keyInitiativeEditor.progressView.selectorPlaceholder} />
          )}
        </span>
        <i
          className={`kbase kbase-omni-chevron-down ${styles.dropdownArrow} ${isDropdownOpen ? styles.dropdownArrowOpen : ''}`}
        />
      </button>
      {isDropdownOpen &&
        createPortal(
          <>
            <div className={styles.dropdownBackdrop} onClick={() => setIsDropdownOpen(false)} />
            <div className={styles.dropdownMenu} style={menuStyle}>
              <div className={styles.dropdownItemsList}>
                {PROGRESS_VIEW_ITEMS.map((item) => (
                  <label key={item.key} className={styles.dropdownItem}>
                    <input
                      type="checkbox"
                      checked={progressItems.includes(item.key)}
                      onChange={() => handleToggleItem(item.key)}
                      className={styles.dropdownCheckbox}
                    />
                    <div className={styles.dropdownItemContent}>
                      <span className={styles.dropdownItemLabel}>
                        <Translation text={`${item.key}${PROGRESS_VIEW_LABEL_SUFFIX}`} />
                      </span>
                      <span className={styles.dropdownItemDescription}>
                        <Translation text={`${item.key}${PROGRESS_VIEW_DESC_SUFFIX}`} />
                      </span>
                    </div>
                  </label>
                ))}
              </div>
              <div className={styles.dropdownOkButtonWrapper}>
                <button
                  type="button"
                  className={styles.dropdownOkButton}
                  onClick={() => setIsDropdownOpen(false)}
                >
                  <Translation text={tr.keyInitiativeEditor.progressView.dropdownOkButton} />
                </button>
              </div>
            </div>
          </>,
          document.body
        )}
    </div>
  )
}
